import {
	createStyles,
	makeStyles,
} from '@mui/styles';
import {
	Theme,
} from '@mui/material/styles';
// Import enumerations
import {
	BreakpointWidth
} from '@app/enumerations';

const useStyles = makeStyles((theme: Theme) => {

	return createStyles({
		formBuildingFullAdd_subformContainers: {
			padding: theme.spacing(1, 0),
		},
	});
});

export default useStyles;
